import { defineMessages } from 'react-intl';

export const messages: {
	webSearchPill: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	betaTag: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	webSearchPill: {
		id: 'rovo.conversation.assistant.agent.web-search-pill',
		defaultMessage: 'Web search',
		description:
			'Label text displayed in a pill-shaped badge on agent response messages. Indicates the agent performed web search to generate the response.',
	},
	betaTag: {
		id: 'rovo.conversation.assistant.agent.web-search-pill-beta-tag',
		defaultMessage: 'Beta',
		description:
			'Label text displayed as a beta indicator badge next to or on the web search pill. Indicates the web search feature is in beta/experimental phase.',
	},
});
